//#region ../icons/dist/html/default/chevron.js
const chevronIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" fill=\"none\" aria-hidden=\"true\" viewBox=\"0 0 18 18\"><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"2\" d=\"m11.964 9.014-4.95-4.95m0 9.9 4.95-4.95\"/></svg>";
//#endregion
export { chevronIcon };
